import useMissionRestorePrompt from './hooks/useMissionRestorePrompt';

const MissionRestorePrompt = () => {
  useMissionRestorePrompt();

  return null;
};

export default MissionRestorePrompt;
